import IArticle from "../types/IArticle";
import MpTrackingButtons from "../types/mpTrackingButtons";

export const mpSetUserProperties = () => {

  const trackingPoperties = {
    UserPlatform: 'EMBED_PLAYER'
  };

  // @ts-ignore
  window.mixpanel.people.set(trackingPoperties);

  // @ts-ignore
  window.mixpanel.register(trackingPoperties);
}

export const mpTrackIntervalListen = (article: IArticle, currentProgress: number) => {

  mpSetUserProperties();

  const trackingPoperties = {
    ArticleName: article.name,
    ArticleId: article.id,
    PublisherName: article.publisher.name,
    AudioLengthSecs: Math.round(article.audioLength),
    ListenProgressSecs: Math.round(currentProgress),
    ListenProgressPercent: +((Math.round(currentProgress) / Math.round(article.audioLength) * 100).toFixed(2)),
  }

  // @ts-ignore
  window.mixpanel.track("ArticleListenInterval", trackingPoperties);

  console.log(`Noa - MP - ArticleListenInterval:\n${JSON.stringify(trackingPoperties)}\n`);
}

export const mpTrackButtonClick = (article: IArticle, button: MpTrackingButtons) => {

  const trackingPoperties = {
    ArticleName: article.name,
    ArticleId: article.id,
    PublisherName: article.publisher.name,
    ButtonName: button.toString(),
  }

  // @ts-ignore
  window.mixpanel.track("ButtonClick", trackingPoperties);

  console.log(`Noa - MP - ButtonClick:\n${JSON.stringify(trackingPoperties)}\n`);
}

export const mpGetDistinctId = (): string => {

  // @ts-ignore
  return window.mixpanel.get_distinct_id();
}